export class ForgotPasswordInitRequestDtoModel {
  email?: string;
  mobileNumber?: string;
  messageTemplate?: string;
}
